export type SelectionViewportRect = {
  left: number;
  top: number;
  right: number;
  bottom: number;
};

export class SelectMarqueeTool {
  private readonly overlay: HTMLDivElement;
  private readonly marquee: HTMLDivElement;
  private startX = 0;
  private startY = 0;
  private endX = 0;
  private endY = 0;
  private dragging = false;

  constructor() {
    this.overlay = document.createElement('div');
    this.overlay.style.position = 'fixed';
    this.overlay.style.inset = '0';
    this.overlay.style.pointerEvents = 'none';
    this.overlay.style.zIndex = '9999';

    this.marquee = document.createElement('div');
    this.marquee.style.position = 'fixed';
    this.marquee.style.pointerEvents = 'none';
    this.marquee.style.border = '1px solid rgba(198, 243, 255, 0.95)';
    this.marquee.style.background = 'rgba(198, 243, 255, 0.18)';
    this.marquee.style.boxShadow = '0 0 0 1px rgba(12, 24, 38, 0.2) inset';
    this.marquee.style.display = 'none';

    this.overlay.appendChild(this.marquee);
  }

  attach() {
    if (!this.overlay.parentElement) {
      document.body.appendChild(this.overlay);
    }
  }

  detach() {
    this.overlay.remove();
  }

  isDragging() {
    return this.dragging;
  }

  startDrag(clientX: number, clientY: number) {
    this.dragging = true;
    this.startX = clientX;
    this.startY = clientY;
    this.endX = clientX;
    this.endY = clientY;
    this.marquee.style.display = 'block';
    this.updateMarquee();
  }

  updateDrag(clientX: number, clientY: number) {
    if (!this.dragging) {
      return;
    }

    this.endX = clientX;
    this.endY = clientY;
    this.updateMarquee();
  }

  finishDrag(): SelectionViewportRect | null {
    if (!this.dragging) {
      return null;
    }

    const rect = this.currentRect();
    this.cancelDrag();
    return rect;
  }

  cancelDrag() {
    this.dragging = false;
    this.marquee.style.display = 'none';
  }

  private updateMarquee() {
    const rect = this.currentRect();
    this.marquee.style.left = `${rect.left}px`;
    this.marquee.style.top = `${rect.top}px`;
    this.marquee.style.width = `${Math.max(rect.right - rect.left, 1)}px`;
    this.marquee.style.height = `${Math.max(rect.bottom - rect.top, 1)}px`;
  }

  private currentRect(): SelectionViewportRect {
    return {
      left: Math.min(this.startX, this.endX),
      right: Math.max(this.startX, this.endX),
      top: Math.min(this.startY, this.endY),
      bottom: Math.max(this.startY, this.endY),
    };
  }
}
